import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { Customer } from 'graphql/models/generated';

import { CustomerConditionsModalComponent } from '../conditions-modal/conditions-modal.component';

@Component({
  selector: 'app-customer-custom-conditions-modal',
  templateUrl: './custom-conditions-modal.component.html',
  styleUrls: ['./custom-conditions-modal.component.scss']
})
export class CustomerCustomConditionsModalComponent {
  showDefaultConditions = false;

  useDefaultConditions = false;

  @ViewChild(CustomerConditionsModalComponent) modalComponent!: CustomerConditionsModalComponent;

  get form(): UntypedFormGroup {
    return this.modalComponent.form;
  }

  onSubmit(): Observable<Customer> {
    return this.modalComponent.onSubmit();
  }
}
